/**
 * Meta Pixel AddToCart with value + currency.
 * Call after a successful /cart/add response so Events Manager gets a numeric value > 0.
 * Skips the gift-wrap add-on so it is not treated as a catalog / ads product.
 */
(function () {
  var GIFT_WRAP_VARIANT_ID = 42687836160097;

  function activeCurrency() {
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      return Shopify.currency.active;
    }
    return 'USD';
  }

  function centsToMoney(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return null;
    return n / 100;
  }

  function trackOne(item) {
    if (typeof fbq !== 'function' || !item) return false;

    var variantId = Number(item.variant_id || item.id);
    if (variantId === GIFT_WRAP_VARIANT_ID) return false;

    var qty = Number(item.quantity) || 1;
    var unitCents = item.final_price != null ? item.final_price : item.price;
    var lineCents =
      item.final_line_price != null
        ? item.final_line_price
        : item.line_price != null
          ? item.line_price
          : null;

    var value =
      lineCents != null ? centsToMoney(lineCents) : centsToMoney(unitCents) != null ? centsToMoney(unitCents) * qty : null;

    // Meta requires value > 0; skip free / gift lines that would fail diagnostics.
    if (!(value > 0)) return false;

    var id = String(item.variant_id || item.id || '');
    if (!id) return false;

    var unitPrice = centsToMoney(unitCents);
    var payload = {
      value: Number(value.toFixed(2)),
      currency: activeCurrency(),
      content_ids: [id],
      content_type: 'product',
      num_items: qty,
      contents: [
        {
          id: id,
          quantity: qty,
        },
      ],
    };

    var name = item.product_title || item.title;
    if (name) payload.content_name = name;
    if (unitPrice != null && unitPrice > 0) {
      payload.contents[0].item_price = Number(unitPrice.toFixed(2));
    }

    fbq('track', 'AddToCart', payload);
    return true;
  }

  function trackAddToCart(response) {
    if (!response || response.status) return;
    if (Array.isArray(response.items)) {
      response.items.forEach(trackOne);
      return;
    }
    trackOne(response);
  }

  window.IRMetaPixel = {
    trackAddToCart: trackAddToCart,
  };
})();
